import davlogo from '../images/DAVCMCLOGO.png';
import lnmlogo from '../images/LNMIITLogo.png';
import hashedinlogo from '../images/hashedinbydeloitte.png';
import angularlogo from '../images/angularlogo.png';
import antlogo from '../images/antdesignlogo.png';
import claylogo from '../images/clay_logo.png';
import formiklogo from '../images/formiklogo.png';
import rtklogo from '../images/RTKlogo.jpg';
import tailwindlogo from '../images/tailwindcsslogo.png';
import typescriptlogo from '../images/typescriptlogo.png';
import vuelogo from '../images/vuejslogo.png';
import cpplogo from '../images/cpplogo.png';
import javalogo from '../images/javalogo.png';
import springbootlogo from '../images/sprinbootlogo.png';
// import figmalogo  from '../images/figmalogo.png';
import postmanlogo from '../images/postmanlogo.png';
import gitlogo from '../images/gitlogo.png';
import playtubeimg from '../images/PlayTubeImg.png';
import genaifliximg from '../images/GenAIFlixSS.png';
import rapidcanvaslogo from '../images/rclogo.svg';

export const Bio = {
  name: "Anuj Goyal",
  roles: [
    "Full Stack Developer",
    "Frontend Developer",
    "UI/UX Developer",
    "Backend Engineer",
    "Software Engineer",
  ],
  description:
    "I am an enthusiastic and adaptable individual, continuously seeking out new challenges. Driven by a strong desire for knowledge, I am committed to delivering exceptional results. Fueled by a positive mindset and a belief in continuous growth, I am prepared to make a significant impact and accomplish remarkable feats.",
  github: "https://github.com/GoyalAnuj973",
  resume:
    "https://drive.google.com/file/d/1W1qxL9r_VGN0cbtLQlh1oQzgtgQbXxUx/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/anuj-goyal-370117139/",
  twitter: "https://x.com/goyalanuj973?s=11",
  insta: "https://www.instagram.com/__anuj_goyal?igsh=b2Z5YWRnMWNsM2tv&utm_source=qr",
  facebook: "https://www.facebook.com/share/wgvfX6wmro762kSv/?mibextid=WC7FNe",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image: "https://cdn.simpleicons.org/css3/1572B6",
      },
      {
        name: "JavaScript",
        image: "https://cdn.simpleicons.org/javascript/F7DF1E",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Angular",
        image: angularlogo,
      },
      {
        name: "Ant Design",
        image: antlogo,
      },
      {
        name: "Clay UI",
        image: claylogo,
      },
      {
        name: "Formik",
        image: formiklogo,
      },
      {
        name: "Redux Toolkit",
        image: rtklogo,
      },
      {
        name: "Tailwind CSS",
        image: tailwindlogo,
      },
      {
        name: "TypeScript",
        image: typescriptlogo,
      },
      {
        name: "Vue Js",
        image: vuelogo,
      },
      // ---- Added from resume ----
      {
        name: "TanStack Query",
        image: "https://api.iconify.design/logos:react-query-icon.svg",
      },
      {
        name: "React Router",
        image: "https://api.iconify.design/logos:react-router.svg",
      },
      {
        name: "React Flow",
        // NOTE: no widely-mirrored brand icon exists for React Flow; using a generic flow/diagram icon instead
        image: "https://api.iconify.design/mdi:sitemap.svg?color=%23ffffff",
      },
      {
        name: "Monaco Editor",
        // NOTE: no dedicated brand icon; using VS Code icon as a stand-in since Monaco is VS Code's editor core
        image: "https://api.iconify.design/logos:visual-studio-code.svg",
      },
      {
        name: "Vite",
        image: "https://api.iconify.design/logos:vitejs.svg",
      },
      {
        name: "Webpack",
        image: "https://api.iconify.design/logos:webpack.svg",
      },
      {
        name: "Jest",
        image: "https://api.iconify.design/logos:jest.svg",
      },
      {
        name: "React Testing Library",
        image: "https://api.iconify.design/logos:testing-library.svg",
      },
      {
        name: "Axios",
        image: "https://api.iconify.design/logos:axios.svg",
      },
      {
        name: "Sass/SCSS",
        image: "https://api.iconify.design/logos:sass.svg",
      },
      {
        name: "React Native",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        // reusing the React logo since React Native shares the same brand mark
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image: "https://cdn.simpleicons.org/express/FFFFFF",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "C++",
        image: cpplogo,
      },
      {
        name: "Java",
        image: javalogo,
      },
      {
        name: "Spring Boot",
        image: springbootlogo,
      },
      // ---- Added from resume ----
      {
        name: "Django",
        image: "https://api.iconify.design/logos:django-icon.svg",
      },
      {
        name: "FastAPI",
        image: "https://api.iconify.design/logos:fastapi-icon.svg",
      },
      {
        name: "JWT / OAuth2",
        image: "https://api.iconify.design/logos:jwt-icon.svg",
      },
      {
        name: "Hibernate / JPA",
        image: "https://api.iconify.design/logos:hibernate.svg",
      },
      {
        name: "Protocol Buffers",
        // NOTE: no widely-mirrored brand icon exists for Protocol Buffers; using a generic data/package icon instead
        image: "https://api.iconify.design/mdi:package-variant-closed.svg?color=%23ffffff",
      },
      {
        name: "Redis Queue / Celery",
        image: "https://cdn.simpleicons.org/celery/37814A",
      },
      {
        name: "SSE",
        // NOTE: Server-Sent Events has no brand icon; using a generic broadcast/signal icon
        image: "https://api.iconify.design/mdi:access-point.svg",
      },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  // ---- New section added from resume ----
  {
    title: "Databases",
    skills: [
      {
        name: "Redis",
        image: "https://api.iconify.design/logos:redis.svg",
      },
      {
        name: "Elasticsearch",
        image: "https://api.iconify.design/logos:elasticsearch.svg",
      },
    ],
  },
  // ---- New section added from resume ----
  {
    title: "Cloud & DevOps",
    skills: [
      {
        name: "GCP",
        image: "https://api.iconify.design/logos:google-cloud.svg",
      },
      {
        name: "AWS",
        image: "https://api.iconify.design/logos:aws.svg",
      },
      {
        name: "Azure",
        image: "https://api.iconify.design/logos:microsoft-azure.svg",
      },
      {
        name: "Kubernetes",
        image: "https://api.iconify.design/logos:kubernetes.svg",
      },
      {
        name: "Cloudflare",
        image: "https://api.iconify.design/logos:cloudflare-icon.svg",
      },
      {
        name: "Nginx",
        image: "https://api.iconify.design/logos:nginx.svg",
      },
      {
        name: "GitHub Actions",
        image: "https://api.iconify.design/logos:github-actions.svg",
      },
      {
        name: "Electron",
        image: "https://api.iconify.design/logos:electron.svg",
      },
    ],
  },
  // ---- New section added from resume ----
  {
    title: "AI / LLM",
    skills: [
      {
        name: "OpenAI",
        // NOTE: OpenAI's mark is monochrome black by brand guideline; forcing white for visibility on dark backgrounds
        image: "https://api.iconify.design/logos:openai-icon.svg",
      },
      {
        name: "Anthropic",
        image: "https://cdn.simpleicons.org/anthropic/D97757",
      },
      {
        name: "LangChain",
        image: "https://cdn.simpleicons.org/langchain/FFFFFF",
      },
      {
        name: "LiteLLM",
        // NOTE: no widely-mirrored brand icon; using a generic AI/chip icon, forced white for visibility on dark backgrounds
        image: "https://api.iconify.design/mdi:chip.svg?color=%23ffffff",
      },
      {
        name: "Vercel AI SDK",
        // NOTE: Vercel's mark is a monochrome black triangle by brand guideline; forcing white for visibility on dark backgrounds
        image: "https://cdn.simpleicons.org/vercel/FFFFFF",
      },
      {
        name: "RAG / Vector DBs",
        // NOTE: no single brand icon for this concept; using a generic vector/database icon, forced white for visibility
        image: "https://api.iconify.design/mdi:vector-square.svg?color=%23ffffff",
      },
      {
        name: "MCP",
        // NOTE: Model Context Protocol has no widely-mirrored brand icon yet, forced white for visibility
        image: "https://api.iconify.design/mdi:connection.svg?color=%23ffffff",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:  gitlogo,
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image: "https://cdn.simpleicons.org/netlify/00C7B7",
      },
      {
        name: "VS Code",
        image: "https://api.iconify.design/logos:visual-studio-code.svg",
      },
      {
        name: "Postman",
        image: postmanlogo,
      },
      {
        name: "Figma",
        // NOTE: this used to reference the local `figmalogo` import — if that file is missing/corrupted
        // at src/images/figmalogo.png, swap back to `image: figmalogo,` once you've verified the asset exists.
        // Using a reliable CDN fallback for now:
        image: "https://cdn.simpleicons.org/figma/F24E1E",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: rapidcanvaslogo,
    role: "Software Engineer - Fullstack",
    company: "RapidCanvas",
    date: "Oct 2025 - Present",
    desc: "Re-platformed a ~250K-LOC React app to React 18, Vite 7, and TypeScript with isolated Redux stores in a zero-downtime migration, cutting build time by 65% and first load by 40%. Built in-browser VS Code (code-server) editing for DataApps and FastAPI apps — a React iframe workspace backed by Spring services that run code-server inside the user's own Kubernetes pod, with GitHub OAuth and one-click publish-and-redeploy. Delivered end-to-end FastAPI hosting on Kubernetes (deploy from a ZIP or Git repo with zero infra setup) including an embedded Swagger console and live logs over SSE, powered by a Spring/Protobuf launcher that provisions Kubernetes CRDs with autoscaling. Built Code Modules, letting users import reusable Python libraries into their pipelines via a React and Monaco Editor UI. Built the drag-and-drop ML-pipeline Canvas on React Flow v12 and used hash-keyed memoization to cut canvas re-renders by ~70%.",
    skills: [
      "React 18",
      "Vite",
      "TypeScript",
      "Redux",
      "React Flow",
      "Monaco Editor",
      "Spring Boot",
      "FastAPI",
      "Python",
      "Kubernetes",
      "Docker",
      "GCP",
      "Protocol Buffers",
      "SSE",
      "GitHub OAuth",
    ],
    // doc: "",
  },
  {
    id: 1,
    img: hashedinlogo,
    role: "Software Development Engineer",
    company: "Hashedin By Deloitte",
    date: "Sep 2022 - Sep 2025",
    desc: "Built custom Looker dashboards and JS visualizations for Deloitte and Google accounts, automating KPI aggregation across entities and cutting manual reporting by 90% with sub-1-second render times. Developed Google Orion's AI-powered UI using React, TypeScript, and Tailwind CSS for real-time document analysis and contract extraction, integrating WebSocket and OpenAI to achieve 55% faster response times and reduce manual review by 70%. Led frontend development for Alnylam Pharmaceuticals, building medical workflows with React, Redux Toolkit, and Formik, integrated with OpenAI, Bedrock, and PGVector, cutting document generation time by 60% and manual effort by 70%. Earlier on this team, made a Reusable Global Search Product integrated across several of Broadcom's products, decreasing repetitive development work by 70% and improving search efficiency by 40%. Also built the UI for Broadcom's enterprise product, cutting computational billing time by ~50% by billing users per exact virtual CPU usage, and was a core UI contributor to a DigitalTwin product for real-time wind power plant monitoring using ReactJS, Tailwind CSS, Chart.js, MySQL, AWS, Clay UI, Formik, and Yup, reducing operating costs and manual maintenance while maximizing power generation throughput.",
    skills: [
      "React",
      "TypeScript",
      "Tailwind CSS",
      "Redux Toolkit",
      "Formik",
      "OpenAI",
      "AWS Bedrock",
      "PGVector",
      "WebSocket",
      "Looker",
      "Docker",
      "AWS",
      "EC2",
      "AngularJS",
      "Nginx",
      "JavaScript",
      "Node Js",
      "Next Js",
      "HTML5",
      "CSS3",
      "Yup",
      "BootStrap",
      "Redux",
      "RTK",
      "Material UI",
      "Clay UI",
      "Ant Design",
      "Java",
      "SpringBoot",
      "GCP",
      "SQL"
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  // {
  //   id: 0,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
  //   role: "Frontend Engineer Intern",
  //   company: "Neurobit",
  //   date: "June 2023 - Present",
  //   desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
  //   skills: [
  //     "ReactJS",
  //     "Redux",
  //     "NodeJs",
  //     "Material UI",
  //     "HTML",
  //     "CSS",
  //     "JavaScript",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  // },
  {
    id: 2,
    img: hashedinlogo,
    role: "Associate Software Engineer",
    company: "Hashedin By Deloitte",
    date: "Jan 2022 - Sep 2022",
    desc: "Worked on a fleet-based logistics product, improving truck driver efficiency at work by 80% and cutting logistics operational costs by ~50% by providing real-time data about the truck and potential near-future issues to be taken care of.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "AWS",
      "MongoDB",
      "TypeScript",
      "Spring Boot",
      "Python",
    ],
  },
  {
    id: 3,
    // TODO: replace with an actual Vixi Technologies logo once you have one
    img: "https://ui-avatars.com/api/?name=Vixi+Technologies&background=854CE6&color=fff&size=128",
    role: "Freelance Software Development Engineer",
    company: "Vixi Technologies",
    date: "Jul 2021 - Dec 2021",
    desc: "Built the end-to-end frontend for Vixichain's Presale and CRM platforms using Vue.js, including OTP-based login and KYC review flows for streamlined client verification. Improved load times by 35% and boosted workflow efficiency by 25%, contributing to a successful fintech product launch across crypto and customer management systems, while working remotely and closely with product and QA teams.",
    skills: [
      "Vue.js",
      "JavaScript",
      "HTML",
      "CSS",
      "REST APIs",
      "OTP Authentication",
    ],
    // doc: "",
  },
  {
    id: 4,
    // TODO: replace with an actual hEGI logo once you have one
    img: "https://ui-avatars.com/api/?name=hEGI&background=854CE6&color=fff&size=128",
    role: "Freelance Software Development Engineer",
    company: "hEGI",
    date: "Jan 2021 - May 2021",
    desc: "Led frontend development and backend integration, enhancing UI/UX and boosting user engagement by 25%. Optimized performance, cutting load times by 30% and improving efficiency by 20%. Collaborated cross-functionally to ensure smooth deployment, driving a 15% rise in user satisfaction.",
    skills: [
      "JavaScript",
      "HTML",
      "CSS",
      "React",
      "Node Js",
    ],
    // doc: "",
  },
  // {
  //   id: 2,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
  //   role: "Open Source Contributor ",
  //   company: "GirlScript Summer of Code",
  //   date: "May 2023 - Present",
  //   desc: "Contributing to different open-source projects and learn from industry experts",
  //   doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
  // },
  // {
  //   id: 3,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
  //   role: "Android Developer",
  //   company: "DSC KIIT",
  //   date: "Nov2021 - Present",
  //   desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
  //   skills: [
  //     "Leadership",
  //     "Mobile Application Development",
  //     "Kotlin",
  //     "XML",
  //     "Figma",
  //   ],
  // },
  // {
  //   id: 4,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
  //   role: "Android Developer Intern",
  //   company: "Rudraksha Welffare Foundation",
  //   date: "June 2021 - Oct 2021",
  //   desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
  //   skills: [
  //     "Android",
  //     "Java",
  //     "Kotlin",
  //     "XML",
  //     "Node Js",
  //     "Cloud Firestore",
  //     "Firebase",
  //     "Figma",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  // },
];

export const education = [
  {
    id: 0,
    img: lnmlogo,
    school: "L.N.M. Institute Of Information Technology, Jaipur",
    date: "Aug 2018 - May 2022",
    grade: "7.62 CGPA",
    desc: "I had taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I was also in the Entrepreneurship Cell and Artist and Sponsorship Management Team of Our Cultural Fest.",
    degree: "Bachelor of Technology - BTech, Computer and Communication Engineering (Majors: CSE)",
  },
  {
    id: 1,
    img: davlogo,
    school: "Mahrishi Dayanand Public School, Jaipur",
    date: "Apr 2017 - Mar 2018",
    grade: "75.4%",
    desc: "I completed my class 12 high school education at Mahrishi Dayanand Public School, Jaipur, where I studied Physics, Chemistry and Maths as Majors.",
    degree: "CBSE(XII), Science (PCM)",
  },
  {
    id: 2,
    img: davlogo,
    school: "D.A.V. Centenary Public School, Jaipur",
    date: "Apr 2014 - Apr 2015",
    grade: "9.8 CGPA",
    desc: "I completed my class 10 education at D.A.V. Centenary Public School, Jaipur, where I studied Science with Computer Application.",
    degree: "CBSE(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 9,
    title: "PlayTube",
    // date: "Jun 2023 - Jul 2023",
    description:
      "YouTube like Interface having Hamburger Menu, Video Cards, Search Box, Comments Section Live Chat.",
    image: playtubeimg,
    tags: [
      "React JS",
      "Redux",
      "Redux Tool Kit",
      "Moment JS",
      "React Icons",
      "Tailwind CSS",
      "React Router DOM",
      "Google Developer Console",
      "Netlify",
    ],
    category: "web app",
    github: "https://github.com/GoyalAnuj973/PlayTube",
    webapp: "https://main--playtube-by-anuj.netlify.app/",
  },
  {
    id: 0,
    title: "GenAIFlix",
    // date: "Apr 2023 - May 2023",
    description:
      "Firebase Authenticated Netflix Interface with Generative AI for searching and suggestions as per the respective user.",
    image: genaifliximg,
    tags: ["React Js", "JavaScript", "Open AI-GPT-3(API key)", "HTML", "CSS", "Google Firebase Authentication", "Tailwind CSS", "Redux"],
    category: "web app",
    github: "https://github.com/GoyalAnuj973/GenAIFlix",
    webapp: "https://genaiflix.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 1,
    title: "Project Management Portal",
    // date: "Oct 2022 - Present",
    description:
      "Web Application for managing the projects and get the information of particular projects like it’s supervisor, assignee, etc.",
    image:
      "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    tags: [
      "Angular Js",
      "TypeScript",
      "Axios",
      "Material-ui",
    ],
    category: "web app",
    github: "https://github.com/GoyalAnuj973/Project-Management-Portal",
    // webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "E-learning Platform",
    // date: "Jan 2023 - Mar 2023",
    description:
      "E-learning Software for online courses similar to Udemy having APIs for respective functionalities.",
    image:
      "", //https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png
    tags: ["Java", "Springboot", "MySQL", "Postman"],
    category: "web app",
    github: "https://github.com/GoyalAnuj973/E-learning-Platform",
    // webapp: "https://brain-tumor.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 3,
    title: "Target Marketing Tool",
    // date: "Dec 2021 - Apr 2022",
    description:
      "Full stack web application allowing users to do targeted marketing as per their segments, provide analytics to improve their sales by creating campaigns.",
    image:
      "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
    tags: ["ReactJS", "Material-UI", "PostgreSQL", "Python", "Django", "Postman"],
    category: "web app",
    github: "https://github.com/GoyalAnuj973/Target-Marketing-Tool",
    // webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 10,
    title: "Task Allocator",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Software through which organizations/companies can allocate projects and the tasks included to respective teams and manage the progress report like Jira Software.",
    image:
      "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
    tags: ["Python", "Django", "PostgreSQL", "Postman"],
    category: "web app",
    github: "https://github.com/GoyalAnuj973/Task-Allocator",
    // webapp: "https://github.com/rishavchanda/Job-finder-App",
  },
  // {
  //   id: 4,
  //   title: "Whatsapp Clone",
  //   date: "Jul 2021",
  //   description:
  //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
  //   image:
  //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
  //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
  //   webapp: "https://whatsapp-clone-rishav.web.app",
  // },
  // {
  //   id: 5,
  //   title: "Todo Web App",
  //   date: "Jun 2021",
  //   description:
  //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   image:
  //     "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  // },
  // {
  //   id: 6,
  //   title: "Breaking Bad",
  //   date: "Jun 2021",
  //   description:
  //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
  //   image:
  //     "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
  //   tags: ["React Js", "API", "Axios", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Breaking-Bad",
  //   webapp: "https://breaking-bad-webapp.netlify.app",
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  // {
  //   id: 8,
  //   title: "Face Recognition",
  //   date: "Jan 2021",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // },
];

// export const TimeLineData = [
//   { year: 2017, text: "Started my journey" },
//   { year: 2018, text: "Worked as a freelance developer" },
//   { year: 2019, text: "Founded JavaScript Mastery" },
//   { year: 2020, text: "Shared my projects with the world" },
//   { year: 2021, text: "Started my own platform" },
// ];
